import styled, { keyframes } from 'styled-components';

const fadeIn = keyframes`
  from { opacity: 0; transform: translateY(6px); }
  to { opacity: 1; transform: translateY(0); }
`;

const pop = keyframes`
  0% { transform: scale(0.6); opacity: 0; }
  60% { transform: scale(1.08); opacity: 1; }
  100% { transform: scale(1); }
`;

const WizardWrapper = styled.div`
  font-family: Inter, sans-serif;

  .wiz-header {
    display: flex;
    align-items: center;
    gap: 16px;
    padding: 24px 24px 16px;
  }

  .wiz-title {
    margin: 0;
    font-size: 20px;
    font-weight: 700;
    line-height: 28px;
    color: #1a1a1a;
  }

  .wiz-subtitle {
    margin: 2px 0 0;
    font-size: 13px;
    line-height: 18px;
    color: #8c8c8c;
  }

  .wiz-steps {
    padding: 0 24px 16px;
  }

  .wiz-body {
    min-height: 280px;
    max-height: 52vh;
    overflow-y: auto;
    padding: 4px 24px 16px;
    border-top: 1px solid #ececec;
  }

  .wiz-toolbar {
    position: sticky;
    top: 0;
    z-index: 1;
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 12px;
    padding: 12px 0;
    background: #fff;
  }

  .wiz-list {
    display: flex;
    flex-direction: column;
    gap: 8px;
    animation: ${fadeIn} 0.25s ease-out both;
  }

  .ant-checkbox-wrapper.wiz-row,
  .ant-radio-wrapper.wiz-row {
    display: flex;
    align-items: center;
    width: 100%;
    margin: 0;
    padding: 12px 14px;
    border: 1px solid #ececec;
    border-radius: 8px;
    transition: border-color 0.15s ease, background 0.15s ease;

    &:hover {
      border-color: #ffdbc6;
    }

    &.ant-checkbox-wrapper-checked,
    &.ant-radio-wrapper-checked {
      border-color: #fc8543;
      background: #fff8f4;
    }

    &.ant-checkbox-wrapper-disabled,
    &.ant-radio-wrapper-disabled {
      opacity: 0.55;
    }

    &::after {
      display: none;
    }

    & > span:last-child {
      display: flex;
      align-items: center;
      gap: 12px;
      flex: 1;
      min-width: 0;
      padding-right: 0;
    }
  }

  .wiz-row-main {
    flex: 1;
    min-width: 0;
  }

  .wiz-row-title {
    display: flex;
    align-items: center;
    gap: 8px;
    font-size: 14px;
    font-weight: 600;
    color: #080808;

    span:first-child {
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }

    .ant-tag {
      margin: 0;
      font-weight: 500;
    }
  }

  .wiz-row-meta {
    margin-top: 2px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    font-size: 12px;
    color: #909090;

    em {
      font-style: normal;
      color: #d69b25;
    }
  }

  .wiz-avatar {
    flex: none;
    background: #ffebe0;
    color: #fc8543;
    font-weight: 600;
  }

  .wiz-review {
    display: flex;
    flex-direction: column;
    gap: 20px;
    padding-top: 16px;
    animation: ${fadeIn} 0.25s ease-out both;
  }

  .wiz-review-section h4 {
    margin: 0 0 8px;
    font-size: 12px;
    font-weight: 600;
    letter-spacing: 0.04em;
    text-transform: uppercase;
    color: #909090;
  }

  .wiz-review-card {
    padding: 14px 16px;
    border: 1px solid #fc8543;
    border-radius: 8px;
    background: #fff8f4;
  }

  .wiz-details {
    display: grid;
    grid-template-columns: max-content 1fr;
    gap: 6px 16px;
    margin: 10px 0 0;
    font-size: 13px;

    dt {
      color: #909090;
    }

    dd {
      margin: 0;
      min-width: 0;
      overflow-wrap: anywhere;
      color: #3b3b3c;
    }
  }

  .wiz-review-group + .wiz-review-group {
    margin-top: 12px;
  }

  .wiz-review-label {
    display: block;
    margin-bottom: 6px;
    font-size: 14px;
    font-weight: 600;
    color: #080808;
  }

  .wiz-name-list {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    gap: 6px;

    .ant-tag {
      margin: 0;
    }
  }

  .wiz-more,
  .wiz-muted {
    font-size: 13px;
    color: #909090;
  }

  .wiz-muted {
    margin: 10px 0 0;
  }

  .wiz-center {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    min-height: 280px;
    padding: 24px 0;
    text-align: center;

    h3 {
      margin: 20px 0 4px;
      font-size: 18px;
      font-weight: 700;
      color: #080808;
    }

    p {
      margin: 0;
      color: #5c5c5c;
    }
  }

  .wiz-done-icon {
    display: grid;
    place-items: center;
    width: 56px;
    height: 56px;
    border-radius: 50%;
    background: #e5f5e9;
    color: #009e1f;
    font-size: 24px;
    animation: ${pop} 0.45s ease-out both;
  }

  .wiz-skipped {
    width: 100%;
    margin-top: 16px;
    text-align: left;

    ul {
      margin: 4px 0 0;
      padding-left: 18px;
    }
  }

  .wiz-footer {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 12px;
    padding: 16px 24px;
    border-top: 1px solid #ececec;

    .wiz-footer-actions {
      display: flex;
      gap: 12px;
    }
  }

  @media (prefers-reduced-motion: reduce) {
    .wiz-list,
    .wiz-review,
    .wiz-done-icon {
      animation: none;
    }
  }
`;

export default WizardWrapper;
